module.exports = __webpack_public_path__ + "static/media/presis.8d8d461a.m4a";